// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"common":"0adb6e82720961dd","apps_pwi_src_app_components_personal-wealth-inventory_personal-wealth-inventory_component_ts":"5bb136c47853d749","apps_pwi_src_app_components_client-data_client-data_component_ts":"dc72edcd2743edec"}[chunkId] + ".js";
};